// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2HpqN","list":"styles_list__1fzTh"};